/**
 * Lightweight i18n dictionary.
 * Tax / IRD / NZ terms (GST, PAYE, IRD, invoice, KiwiSaver) intentionally kept in English
 * for the Taglish track — that's how Filipino tradies actually use them.
 */
const dict = {
  // ----------------------------------------------------------------
  // NAV / LAYOUT
  // ----------------------------------------------------------------
  "nav.gst": { en: "GST", tl: "GST" },
  "nav.quote": { en: "Quote", tl: "Quote" },
  "nav.margin": { en: "Margin vs Markup", tl: "Margin vs Markup" },
  "nav.expense": { en: "Business or Personal", tl: "Business o Personal?" },
  "nav.budget": { en: "Budget Planner", tl: "Plano sa Pera" },
  "nav.mileage": { en: "Mileage", tl: "Mileage" },
  "nav.tax": { en: "Tax / PAYE", tl: "Tax / PAYE" },
  "nav.dashboard": { en: "Dashboard", tl: "Dashboard" },
  "nav.clients": { en: "Clients", tl: "Mga Kliyente" },
  "nav.jobs": { en: "Jobs", tl: "Mga Trabaho" },
  "nav.invoices": { en: "Invoices", tl: "Mga Invoice" },
  "nav.settings": { en: "Settings", tl: "Settings" },
  "nav.admin": { en: "Admin", tl: "Admin" },
  "nav.upgrade_free": { en: "Upgrade — free", tl: "Mag-upgrade — libre" },
  "nav.main_site": { en: "Main site ↗", tl: "Main site ↗" },
  "nav.calculators_only": { en: "Calculators only — no saving", tl: "Mga calculator lang — walang save" },

  // ----------------------------------------------------------------
  // LANDING
  // ----------------------------------------------------------------
  "landing.want_save": { en: "Want to save your work?", tl: "Gusto mong i-save ang gawa mo?" },
  "landing.pick_above": { en: "Pick a calculator above.", tl: "Pumili ng calculator sa taas." },
  "landing.what_each_eyebrow": { en: "What each one does", tl: "Ano'ng ginagawa ng bawat isa" },
  "landing.not_sure_sub": {
    en: "Not sure which one? Here's what each does — but the easiest is just to tap one.",
    tl: "Hindi sigurado kung alin? Ito ang ginagawa ng bawat isa — pero pinakamadali, i-tap na lang ang isa.",
  },
  "landing.eyebrow": {
    en: "Free for NZ tradies · backed by NZ Taxation Ltd",
    tl: "Libre para sa mga NZ tradie · galing sa NZ Taxation Ltd",
  },
  "landing.chip": { en: "Free · No signup needed", tl: "Libre · Walang signup" },
  "landing.hero_h1_line1": { en: "Tradie Calculators", tl: "Mga Calculator" },
  "landing.hero_h1_line2": { en: "for NZ.", tl: "para sa NZ." },
  "landing.hero_sub_short": {
    en: "Tap one to start — GST, quotes, mileage, tax, margin & markup. Built by IRD-registered tax agents at NZ Taxation Ltd.",
    tl: "I-tap para magsimula — GST, quotes, mileage, tax, margin at markup. Gawa ng IRD-registered tax agents sa NZ Taxation Ltd.",
  },
  "landing.hero_title_1": { en: "Maths for tradies.", tl: "Math para sa tradie." },
  "landing.hero_title_2": { en: "Hammer-time fast.", tl: "Bilisan na, parang martilyo." },
  "landing.hero_sub": {
    en: "Seven dead-simple calculators built for sole-trader sparkies, chippies, plumbers and painters across Aotearoa. Quote jobs, sort GST, track mileage, plan your budget — and find out exactly what you'll owe IRD.",
    tl: "Pitong sobrang simpleng calculator para sa mga sole-trader na sparky, chippy, plumber at painter sa buong Aotearoa. Mag-quote ng trabaho, ayusin ang GST, i-track ang mileage, i-plano ang budget — at alamin kung magkano ang utang mo sa IRD.",
  },
  "landing.cta_register_short": { en: "Sign up", tl: "Mag-sign up" },
  "landing.cta_start": { en: "Start calculating — free", tl: "Simulan na — libre" },
  "landing.cta_register": { en: "Create free account", tl: "Gumawa ng libreng account" },
  "landing.cta_login": { en: "Login", tl: "Mag-login" },
  "landing.section_features_eyebrow": { en: "What's inside", tl: "Ano'ng laman" },
  "landing.section_features_title": {
    en: "Seven tools. Zero spreadsheet headaches.",
    tl: "Pitong tools. Zero sakit ng ulo sa spreadsheet.",
  },

  // Feature copy
  "feat.gst.title": { en: "GST Calculator", tl: "GST Calculator" },
  "feat.gst.desc": {
    en: "Add 15% on, strip 15% out, or split a total. Three clicks, done.",
    tl: "Idagdag ang 15%, alisin ang 15%, o hatiin ang total. Tatlong click lang, tapos na.",
  },
  "feat.quote.title": { en: "Quote / Invoice", tl: "Quote / Invoice" },
  "feat.quote.desc": {
    en: "Labour hours × rate + materials + markup. Spits out a quote your client can read.",
    tl: "Oras ng trabaho × rate + materyales + markup. May lalabas na quote na madaling basahin ng kliyente.",
  },
  "feat.margin.title": { en: "Margin vs Markup", tl: "Margin vs Markup" },
  "feat.margin.desc": {
    en: "Stop confusing the two. Know exactly what % to add — and what's actually left in the bank.",
    tl: "Tigilan na ang pagkalito sa dalawa. Alamin kung ilang % ang idadagdag — at kung magkano ang talagang matitira sa bangko.",
  },
  "feat.expense.title": { en: "Business or Personal", tl: "Business o Personal?" },
  "feat.expense.desc": {
    en: "Not sure if an expense is claimable? Answer 3 questions — we'll tell you what IRD will likely accept.",
    tl: "Hindi sigurado kung pwedeng i-claim? Sagutin ang 3 tanong — sasabihin namin kung tatanggapin ng IRD.",
  },
  "feat.budget.title": { en: "Budget Planner", tl: "Plano sa Pera" },
  "feat.budget.desc": {
    en: "Plan every dollar — business overheads, tax set-aside, personal life. Spot a shortfall before it bites.",
    tl: "I-plano ang bawat dolyar — business expenses, tax set-aside, personal. Mahanap ang kulang bago pa magulat.",
  },
  "feat.mileage.title": { en: "Mileage Tracker", tl: "Mileage Tracker" },
  "feat.mileage.desc": {
    en: "Log km against IRD rates. Ready for tax time.",
    tl: "I-log ang km gamit ang IRD rates. Handa na pag tax time.",
  },
  "feat.tax.title": { en: "Tax / PAYE", tl: "Tax / PAYE" },
  "feat.tax.desc": {
    en: "Plug in your year. We'll map every bracket and tell you the take-home, weekly and yearly.",
    tl: "Ilagay lang ang annual income mo. I-map namin lahat ng bracket at sasabihin kung magkano ang take-home — kada linggo at kada taon.",
  },

  // Calculator tiles (short subs)
  "tile.gst.sub": { en: "Add or remove 15%", tl: "Idagdag o tanggalin ang 15%" },
  "tile.quote.sub": { en: "Labour + materials", tl: "Trabaho + materyales" },
  "tile.margin.sub": { en: "Don't mix them up", tl: "Wag pagkamalan" },
  "tile.expense.sub": { en: "What can you claim?", tl: "Ano'ng pwedeng i-claim?" },
  "tile.budget.sub": { en: "Plan every dollar", tl: "I-plano ang bawat dolyar" },
  "tile.mileage.sub": { en: "IRD rate × km", tl: "IRD rate × km" },
  "tile.tax.sub": { en: "New brackets · 1 Apr 2025", tl: "Bagong brackets · 1 Abr 2025" },

  // ----------------------------------------------------------------
  // DASHBOARD
  // ----------------------------------------------------------------
  "dashboard.title": { en: "Welcome back.", tl: "Welcome back, boss." },
  "dashboard.subtitle": {
    en: "Pick a calculator and crunch the numbers — or jump into your clients, jobs and invoices.",
    tl: "Pumili ng calculator at kalkulahin — o dumiretso sa kliyente, trabaho, at invoices.",
  },

  // ----------------------------------------------------------------
  // BUDGET PLANNER
  // ----------------------------------------------------------------
  "budget.title": { en: "Budget Planner", tl: "Plano sa Pera" },
  "budget.subtitle": {
    en: "Your trusty map. Plug in what you earn in a typical month, then plan where every dollar goes — business, tax, personal. If the maths doesn't balance, better to find out here than at year-end.",
    tl: "Ito ang gabay mo. Ilagay kung magkano ang kita mo sa isang buwan, tapos i-plano kung saan mapupunta bawat dolyar — business, tax, personal. Kung hindi tugma ang math, mas mabuti malaman dito kesa sa year-end.",
  },
  "budget.how_eyebrow": { en: "How this works", tl: "Paano gumagana 'to" },
  "budget.how_title": {
    en: "Five steps from your income to your back pocket.",
    tl: "Limang hakbang mula sa kita hanggang sa bulsa.",
  },
  "budget.gst_on_label": { en: "GST registered", tl: "GST-registered" },
  "budget.gst_off_label": { en: "Not GST registered", tl: "Hindi GST-registered" },
  "budget.gst_on_hint": {
    en: "Calculations treat income as ex-GST. GST passes through to IRD.",
    tl: "Ex-GST ang turing sa income. Ang GST ay pumupunta sa IRD.",
  },
  "budget.gst_off_hint": {
    en: "Under the $60k threshold. No GST on invoices.",
    tl: "Mas mababa sa $60k threshold. Walang GST sa invoices.",
  },
  "budget.gst_yes_btn": { en: "Yes · I'm registered", tl: "Oo · GST-registered ako" },
  "budget.gst_no_btn": { en: "No · turn on", tl: "Hindi · i-turn on" },
  "budget.income_label_gst": { en: "Monthly income (gross, ex-GST)", tl: "Monthly income (gross, ex-GST)" },
  "budget.income_label_nogst": {
    en: "Monthly income (you're under the $60k GST threshold)",
    tl: "Monthly income (mas mababa ka sa $60k GST threshold)",
  },
  "budget.income_hint": {
    en: "Roughly what hits your account from clients each month",
    tl: "Halos magkano ang pumapasok sa account mo galing sa mga kliyente bawat buwan",
  },
  "budget.income_tax_label": { en: "Income tax set-aside", tl: "Income tax set-aside" },
  "budget.income_tax_hint": {
    en: "Applied to profit (income − business costs). This is what IRD wants for your income tax.",
    tl: "Inilalapat sa profit (income − business costs). Ito ang gusto ng IRD para sa income tax mo.",
  },
  "budget.gst_set_label": { en: "GST set-aside", tl: "GST set-aside" },
  "budget.gst_set_hint": {
    en: "Approx net GST owed to IRD (GST collected on sales minus GST paid on inputs). Drop to ~10% if you have heavy GST-bearing purchases.",
    tl: "Approx net GST na utang sa IRD (GST na nakolekta sa sales minus GST na binayad sa inputs). I-drop sa ~10% kung maraming GST-bearing na binili.",
  },
  "budget.gst_off_explainer": {
    en: "Not GST-registered (under the $60k threshold). Switch on the GST toggle at the top of this page to enable.",
    tl: "Hindi GST-registered (mas mababa sa $60k threshold). I-on ang GST toggle sa taas para mag-enable.",
  },
  "budget.where_eyebrow": { en: "Where every dollar goes", tl: "Saan napupunta bawat dolyar" },
  "budget.legend.business": { en: "Business", tl: "Business" },
  "budget.legend.income_tax": { en: "Income tax", tl: "Income tax" },
  "budget.legend.gst": { en: "GST", tl: "GST" },
  "budget.legend.personal": { en: "Personal", tl: "Personal" },
  "budget.legend.buffer": { en: "Buffer", tl: "Buffer" },
  "budget.cell.income": { en: "Income", tl: "Income" },
  "budget.cell.minus_business": { en: "− Business costs", tl: "− Business costs" },
  "budget.cell.minus_tax": { en: "− Income tax", tl: "− Income tax" },
  "budget.cell.minus_gst": { en: "− GST", tl: "− GST" },
  "budget.cell.takehome": { en: "Take-home", tl: "Take-home" },
  "budget.cell.shortfall": { en: "Shortfall", tl: "Kulang" },
  "budget.cell.buffer": { en: "Buffer left", tl: "Buffer (natira)" },
  "budget.section.business": { en: "Business budget", tl: "Business budget" },
  "budget.section.personal": { en: "Personal budget", tl: "Personal budget" },
  "budget.line.overheads": { en: "Overheads", tl: "Overheads" },
  "budget.line.overheads_hint": {
    en: "Rent, power, phone, software subs",
    tl: "Upa, kuryente, telepono, software subs",
  },
  "budget.line.cogs": { en: "Materials / COGS", tl: "Materyales / COGS" },
  "budget.line.cogs_hint": { en: "Supplies, parts, consumables", tl: "Supplies, parts, gamit" },
  "budget.line.marketing": { en: "Marketing & growth", tl: "Marketing at paglago" },
  "budget.line.marketing_hint": {
    en: "Ads, website, new tools to grow",
    tl: "Ads, website, bagong gamit para lumago",
  },
  "budget.line.basics": { en: "Basics", tl: "Pang-araw-araw" },
  "budget.line.basics_hint": {
    en: "Rent / mortgage, power, groceries",
    tl: "Upa / mortgage, kuryente, groceries",
  },
  "budget.line.downtime": { en: "Downtime", tl: "Pahinga" },
  "budget.line.downtime_hint": {
    en: "Holidays, weekends off — you need a breather",
    tl: "Bakasyon, off sa weekends — kailangan mo rin magpahinga",
  },
  "budget.line.fun": { en: "Fun money", tl: "Pamasaya" },
  "budget.line.fun_hint": {
    en: "Small treats. Don't be a martyr.",
    tl: "Maliliit na treat. Wag namang masyadong martir.",
  },
  "budget.line.savings": { en: "Savings & investments", tl: "Savings at investments" },
  "budget.line.savings_hint": {
    en: "Emergency fund, KiwiSaver, future you",
    tl: "Emergency fund, KiwiSaver, para sa future mo",
  },
  "budget.actuals_eyebrow": { en: "Track actuals", tl: "I-track ang actuals" },
  "budget.actuals_sub": {
    en: "Add what really happened this month and see the variance per line.",
    tl: "Ilagay kung ano talaga ang nangyari ngayong buwan, makikita mo ang variance bawat linya.",
  },
  "budget.actuals_on": { en: "Actuals on", tl: "Actuals on" },
  "budget.actuals_off": { en: "Actuals off", tl: "Actuals off" },
  "budget.verdict.shortfall": { en: "Something's gotta give.", tl: "May kailangang i-adjust." },
  "budget.verdict.shortfall_body": {
    en: "Either bring in more work, trim business costs, or scale back personal spending. Surprise bills will hurt right now.",
    tl: "Mag-hanap ng dagdag na trabaho, bawasan ang business costs, o pigilan ang personal spending. Masakit ang surprise bills ngayon.",
  },
  "budget.verdict.tight": { en: "You're scraping by.", tl: "Sakto-sakto lang." },
  "budget.verdict.tight_body": {
    en: "Aim for a $500+ cushion so a flat tyre or a sick week doesn't push you under.",
    tl: "Tampuhin yung $500+ buffer para kahit flat tyre o sick week, hindi ka magulat.",
  },
  "budget.verdict.healthy": { en: "On track.", tl: "Maganda 'yan." },
  "budget.verdict.healthy_body": {
    en: "Keep an eye on it monthly so a slow week doesn't sneak up on you.",
    tl: "I-check buwan-buwan para hindi ka magulat sa mabagal na linggo.",
  },
  "budget.verdict.plenty": { en: "Plenty of room.", tl: "Sobrang luwag." },
  "budget.verdict.plenty_body": {
    en: "Consider boosting savings or growth spending — money sitting idle isn't working for you.",
    tl: "Dagdagan ang savings o gastos sa paglago — sayang ang perang tumatambay lang.",
  },

  // ----------------------------------------------------------------
  // EMAIL CAPTURE
  // ----------------------------------------------------------------
  "email.eyebrow": { en: "Save this calc", tl: "I-save ang calc na 'to" },
  "email.consent": {
    en: "Send me the occasional NZ tax tip from NZ Taxation Ltd. No spam, ever — unsubscribe one-click.",
    tl: "Padalhan mo ako ng pana-panahong NZ tax tips galing sa NZ Taxation Ltd. Walang spam — one-click unsubscribe.",
  },
  "email.button": { en: "Email it", tl: "I-email" },
  "email.button_loading": { en: "Sending…", tl: "Pinapadala…" },
  "email.success_title": { en: "Sent! Check your inbox.", tl: "Naipadala na! I-check ang inbox mo." },
  "email.success_body": {
    en: "We've fired off your calculator snapshot to your inbox. The first email from us might land in your Spam or Promotions folder — drag it into your inbox once and Gmail/Yahoo will learn to deliver future ones straight there.",
    tl: "Naipadala na namin ang snapshot ng calculator mo. Yung unang email galing sa amin ay baka mapunta sa Spam o Promotions folder — i-drag mo lang sa inbox mo isang beses, at matututo na ang Gmail/Yahoo na ipadala diretso doon next time.",
  },
  "email.success_tip": {
    en: "Tip · don't see it? Check Spam / Junk / Promotions, then mark as 'Not Spam'.",
    tl: "Tip · hindi mo makita? I-check ang Spam / Junk / Promotions, tapos i-mark as 'Not Spam'.",
  },
  "email.label.default": { en: "Email me this calculation", tl: "I-email mo sa akin 'tong calculation" },
  "email.desc.default": {
    en: "We'll send you a clean summary you can save or forward to your accountant.",
    tl: "Padadalhan ka namin ng malinis na summary na pwede mong i-save o i-forward sa accountant mo.",
  },

  // Per-calculator email card labels
  "email.gst.label": { en: "Email me this GST breakdown", tl: "I-email mo sa akin 'tong GST breakdown" },
  "email.gst.desc": { en: "We'll send the excl/incl/IRD slice as a clean summary.", tl: "Ipapadala namin ang excl/incl/IRD breakdown bilang malinis na summary." },
  "email.quote.label": { en: "Email me this quote", tl: "I-email mo sa akin 'tong quote" },
  "email.quote.desc": { en: "A clean summary you can send straight to the client — or your accountant.", tl: "Malinis na summary na pwede mong ipadala diretso sa kliyente — o sa accountant mo." },
  "email.margin.label": { en: "Email me this pricing", tl: "I-email mo sa akin 'tong pricing" },
  "email.margin.desc": { en: "Cost, sell, profit, margin & markup in one tidy email.", tl: "Cost, sell, profit, margin at markup sa isang malinis na email." },
  "email.mileage.label": { en: "Email me this trip", tl: "I-email mo sa akin 'tong trip" },
  "email.mileage.desc": { en: "Snapshot of distance, rate & claim — for your records.", tl: "Snapshot ng distansya, rate at claim — para sa records mo." },
  "email.tax.label": { en: "Email me my tax estimate", tl: "I-email mo sa akin 'tong tax estimate" },
  "email.tax.desc": { en: "Annual + weekly take-home, broken down by bracket.", tl: "Annual + weekly take-home, hinati per bracket." },
  "email.expense.label": { en: "Email me this expense ruling", tl: "I-email mo sa akin 'tong expense ruling" },
  "email.expense.desc": { en: "So you can keep a record if IRD ever asks.", tl: "Para may records ka kung sakaling magtanong ang IRD." },
  "email.budget.label": { en: "Email me this budget", tl: "I-email mo sa akin 'tong budget" },
  "email.budget.desc": { en: "A monthly snapshot you can forward to your accountant — or your partner.", tl: "Monthly snapshot na pwede mong i-forward sa accountant — o sa partner mo." },
  "email.rideshare.label": { en: "Email me this driver breakdown", tl: "I-email mo sa akin 'tong driver breakdown" },
  "email.rideshare.desc": { en: "Your real hourly rate — after tax, ACC & car costs — for your records.", tl: "Ang totoong hourly rate mo — after tax, ACC at car costs — para sa records." },

  // ----------------------------------------------------------------
  // CALCULATOR TITLES + SUBTITLES (all 7)
  // ----------------------------------------------------------------
  "gst.h1": { en: "GST · 15%", tl: "GST · 15%" },
  "gst.sub": {
    en: "Add GST to an exclusive amount, or pull it out of an inclusive one.",
    tl: "Idagdag ang GST sa exclusive amount, o tanggalin sa inclusive amount.",
  },
  "gst.mode.add": { en: "Add GST", tl: "Idagdag GST" },
  "gst.mode.remove": { en: "Remove GST", tl: "Tanggalin GST" },
  "gst.mode.add_hint": {
    en: "ADD MODE: Punch in your sticker price (your money). We'll add 15% GST on top — that's what you charge the customer.",
    tl: "ADD MODE: Ilagay ang sticker price mo (perang sayo). Idadagdag namin ang 15% GST — yan ang sisingilin mo sa customer.",
  },
  "gst.mode.remove_hint": {
    en: "REMOVE MODE: Punch in what the customer paid total. We'll pull the 15% IRD slice out so you can see what's actually yours.",
    tl: "REMOVE MODE: Ilagay ang binayad ng customer sa total. Tatanggalin namin ang 15% IRD slice para makita mo kung magkano talaga ang sayo.",
  },
  "gst.label.amount_excl": { en: "Amount (excl. GST)", tl: "Amount (excl. GST)" },
  "gst.label.amount_incl": { en: "Amount (incl. GST)", tl: "Amount (incl. GST)" },
  "gst.receipt": { en: "Receipt", tl: "Resibo" },
  "gst.excl": { en: "Excl. GST", tl: "Excl. GST" },
  "gst.gst15": { en: "GST 15%", tl: "GST 15%" },
  "gst.incl": { en: "Incl. GST", tl: "Incl. GST" },
  "gst.note.excl": { en: "This is your money — what you actually earn.", tl: "Perang sayo — yung talagang kinikita mo." },
  "gst.note.gst": { en: "This belongs to IRD. You're just holding it for them.", tl: "Sa IRD ito. Naka-hold lang sayo." },
  "gst.note.incl": { en: "This is what the customer pays in total.", tl: "Yan ang babayaran ng customer sa kabuuan." },
  "gst.your_money": { en: "Your money", tl: "Perang sayo" },
  "gst.irds_money": { en: "IRD's money", tl: "Perang sa IRD" },
  "gst.customer_pays": { en: "Customer pays", tl: "Bayad ng customer" },
  "gst.exclusive": { en: "GST exclusive", tl: "GST exclusive" },
  "gst.inclusive": { en: "GST inclusive", tl: "GST inclusive" },

  // QUOTE
  "quote.h1": { en: "Quote / Invoice", tl: "Quote / Invoice" },
  "quote.sub": {
    en: "Labour + materials + markup + GST, the way a sole trader actually quotes a job.",
    tl: "Labour + materyales + markup + GST, kung paano talaga mag-quote ang sole trader ng trabaho.",
  },
  "quote.title_label": { en: "Quote title", tl: "Title ng quote" },
  "quote.title_placeholder": { en: "e.g. Kitchen reno — Smith", tl: "hal. Kitchen reno — Smith" },
  "quote.labour": { en: "Labour", tl: "Labour" },
  "quote.hours": { en: "Hours", tl: "Oras" },
  "quote.rate": { en: "Hourly rate", tl: "Hourly rate" },
  "quote.materials": { en: "Materials", tl: "Materyales" },
  "quote.markup": { en: "Markup %", tl: "Markup %" },
  "quote.gst_inclusive": { en: "GST inclusive", tl: "GST inclusive" },
  "quote.subtotal": { en: "Subtotal", tl: "Subtotal" },
  "quote.gst_line": { en: "GST", tl: "GST" },
  "quote.total": { en: "Total", tl: "Total" },
  "quote.add_item": { en: "+ Add item", tl: "+ Magdagdag ng item" },
  "quote.save": { en: "Save quote", tl: "I-save ang quote" },

  // MARGIN/MARKUP
  "margin.h1": { en: "Margin vs Markup", tl: "Margin vs Markup" },
  "margin.sub": {
    en: "Same profit in dollars — very different percentages. Getting these mixed up is the #1 reason tradies quote jobs that look profitable on paper but leave barely anything in the bank.",
    tl: "Pareho ang profit sa dolyar — pero ibang-iba ang percentages. Itong pagkakamali ang #1 dahilan kung bakit may mga tradie na nag-quote ng trabaho na mukhang kumikita pero halos walang natitira sa bangko.",
  },
  "margin.know": { en: "I know my…", tl: "Alam ko ang…" },
  "margin.mode.markup": { en: "Cost + Markup %", tl: "Cost + Markup %" },
  "margin.mode.margin": { en: "Cost + Margin %", tl: "Cost + Margin %" },
  "margin.mode.price": { en: "Cost + Sell $", tl: "Cost + Sell $" },
  "margin.cost": { en: "Cost (NZD)", tl: "Cost (NZD)" },
  "margin.target_margin": { en: "Target margin %", tl: "Target margin %" },
  "margin.markup_pct": { en: "Markup %", tl: "Markup %" },
  "margin.sell_nzd": { en: "Sell price (NZD)", tl: "Sell price (NZD)" },
  "margin.ticket": { en: "Ticket", tl: "Ticket" },
  "margin.row.cost": { en: "Cost", tl: "Cost" },
  "margin.row.sell": { en: "Sell", tl: "Sell" },
  "margin.row.profit": { en: "Profit", tl: "Profit" },
  "margin.row.markup": { en: "Markup", tl: "Markup" },
  "margin.row.margin": { en: "Margin", tl: "Margin" },

  // MILEAGE
  "mileage.h1": { en: "Mileage", tl: "Mileage" },
  "mileage.sub": {
    en: "Log a trip at the IRD rate. We do the maths so your tax return is bulletproof.",
    tl: "I-log ang trip sa IRD rate. Kami ang gagawa ng math para bulletproof ang tax return mo.",
  },
  "mileage.distance": { en: "Distance (km)", tl: "Distansya (km)" },
  "mileage.rate": { en: "Rate ($/km)", tl: "Rate ($/km)" },
  "mileage.purpose": { en: "Purpose", tl: "Layunin" },
  "mileage.vehicle": { en: "Vehicle", tl: "Sasakyan" },
  "mileage.claim": { en: "Claim amount", tl: "Claim amount" },
  "mileage.save": { en: "Save trip", tl: "I-save ang trip" },

  // TAX/PAYE
  "tax.h1": { en: "Tax / PAYE", tl: "Tax / PAYE" },
  "tax.sub": {
    en: "Plug in your annual income — we map every NZ bracket and tell you the take-home, weekly and yearly.",
    tl: "Ilagay ang annual income mo — i-map namin lahat ng NZ brackets at sasabihin kung magkano ang take-home, weekly at yearly.",
  },
  "tax.income": { en: "Annual income (NZD)", tl: "Annual income (NZD)" },
  "tax.gross": { en: "Gross", tl: "Gross" },
  "tax.tax_line": { en: "Tax", tl: "Tax" },
  "tax.net": { en: "Net take-home", tl: "Net take-home" },
  "tax.effective": { en: "Effective rate", tl: "Effective rate" },
  "tax.frequency": { en: "Show as", tl: "Ipakita bilang" },
  "tax.brackets": { en: "Brackets", tl: "Brackets" },

  // BUSINESS or PERSONAL
  "expense.h1": { en: "Business or Personal?", tl: "Business o Personal?" },
  "expense.sub": {
    en: "Three questions. We tell you what IRD will likely accept as claimable — and how much of it.",
    tl: "Tatlong tanong lang. Sasabihin namin kung ano ang malamang tanggapin ng IRD bilang claimable — at kung magkano sa kabuuan.",
  },
  "expense.cost_label": { en: "Cost (NZD)", tl: "Cost (NZD)" },

  // GENERIC
  "common.calculator": { en: "CALCULATOR", tl: "CALCULATOR" },

  // ----------------------------------------------------------------
  // SIGNUP GATE
  // ----------------------------------------------------------------
  "gate.eyebrow": { en: "calcs in · nice work", tl: "calcs na · galing!" },
  "gate.title": { en: "Want to save your work?", tl: "Gusto mong i-save ang gawa mo?" },
  "gate.body": {
    en: "A free account keeps your quotes, mileage logs, and budgets so you can come back to them next month — no more re-typing.",
    tl: "Ang libreng account ay nag-si-save ng quotes, mileage logs, at budgets para hindi ka na mag-type ulit sa susunod na buwan.",
  },
  "gate.continue_guest": {
    en: "Maybe later · keep using as guest",
    tl: "Mamaya na · ituloy as guest",
  },
};

export function t(key, lang = "en", fallback) {
  const entry = dict[key];
  if (!entry) return fallback ?? key;
  return entry[lang] ?? entry.en ?? fallback ?? key;
}
